import React, { useState, useEffect } from 'react';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import { StringUtils } from '@blumtechgroup/blum-ui-utils';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { editLocationUserInitQuery, LocationUser } from './queries';
import { EditLocationUsersComponent } from '../../../../components/Global';

type UrlParams = {
  user_id: string;
};

const EditLocationUsers = (): React.ReactElement => {
  const navigate = useNavigate();

  const { user_id } = useParams<UrlParams>();

  const [user, setUser] = useState<LocationUser>({
    first_name: '',
    last_name: '',
  });

  const { data: editLocationUserInitData } = useQuery(editLocationUserInitQuery(user_id!), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (editLocationUserInitData) {
      const { users_location_admin_by_pk } = editLocationUserInitData;
      setUser(users_location_admin_by_pk);
    }
  }, [editLocationUserInitData]);

  const handleFinish = () => {
    navigate(`/loc/users/${user_id}`);
  };

  return (
    <DashboardLayout
      breadcrumbs={[
        { label: 'Home', link: '/loc/home' },
        { label: 'Users', link: `/loc/users` },
        { label: StringUtils.stringFromArray([user.first_name, user.last_name]), link: `/loc/users/${user_id}` },
        { label: 'Edit' },
      ]}>
      <EditLocationUsersComponent userId={user_id!} handleFinish={handleFinish} />
    </DashboardLayout>
  );
};

export default EditLocationUsers;
